// RevoltPopup Component
// Displays positioned popup panels with customizable content and sizing

import React from 'react';
import { createPortal } from 'react-dom';
import './RevoltPopup.css';

export function RevoltPopup({
  isOpen,
  onClose,
  children,
  // Positioning props
  top,
  left,
  right,
  bottom,
  transform,
  // Sizing props
  width,
  height,
  minWidth,
  minHeight,
  maxWidth,
  maxHeight,
  // Behavior props
  closeOnBackdrop = true,
  // Additional styling
  panelClassName = '',
}) {
  if (!isOpen) return null;

  if (typeof document === 'undefined' || !document.body) {
    return null;
  }

  const handleBackdropClick = (e) => {
    if (closeOnBackdrop && e.target === e.currentTarget) {
      onClose();
    }
  };

  // Build panel style object
  const panelStyle = {};
  if (top !== undefined) panelStyle.top = typeof top === 'number' ? `${top}px` : top;
  if (left !== undefined) panelStyle.left = typeof left === 'number' ? `${left}px` : left;
  if (right !== undefined) panelStyle.right = typeof right === 'number' ? `${right}px` : right;
  if (bottom !== undefined) panelStyle.bottom = typeof bottom === 'number' ? `${bottom}px` : bottom;
  if (width !== undefined) panelStyle.width = typeof width === 'number' ? `${width}px` : width;
  if (height !== undefined) panelStyle.height = typeof height === 'number' ? `${height}px` : height;
  if (minWidth !== undefined) panelStyle.minWidth = typeof minWidth === 'number' ? `${minWidth}px` : minWidth;
  if (minHeight !== undefined) panelStyle.minHeight = typeof minHeight === 'number' ? `${minHeight}px` : minHeight;
  if (maxWidth !== undefined) panelStyle.maxWidth = typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth;
  if (maxHeight !== undefined) panelStyle.maxHeight = typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight;

  // Support for transform (for centering)
  if (transform !== undefined) panelStyle.transform = transform;

  const popupTree = (
    <div className="popup-backdrop" onClick={handleBackdropClick}>
      <div
        className={`popup-panel ${panelClassName}`.trim()}
        style={panelStyle}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );

  // Portal: avoid position:fixed inside backdrop-filter ancestors (e.g. app section) breaking anchor coords.
  return createPortal(popupTree, document.body);
}